import gql from 'graphql-tag'

export const GET_WISHLIST_BOOK = gql`
  query ($type: Int, $limit: Int, $offset: Int, $query: String) {
    academy_book_wishlists(
      offset: $offset
      limit: $limit
      where: {academy_book: {title: {_ilike: $query}, book_type: {_eq: $type}}}
    ) {
      id
      isbn
      academy_book {
        id
        title
        thumbnail
        isbn
        author_written
        pricing_idr
        count_reviews
        average_rating
        global_user {
          id
          name
          avatar
        }
      }
    }
  }
`

export const GET_WISHLIST_BOOK_COUNT = gql`
  query ($bookIsbns: [String!]) {
    academy_book_wishlists_aggregate(
      where: {isbn: {_in: $bookIsbns}, deleted_at: {_is_null: true}}
    ) {
      aggregate {
        count
      }
    }
  }
`

export const BOOK_TYPES = gql`
  query {
    academy_book_types {
      id
      name
    }
  }
`
